(function () {
  const createSnowflake = () => {
    const snowflake = document.createElement("div");
    snowflake.classList.add("snowflake");
    snowflake.style.left = Math.random() * 100 + "vw";
    snowflake.style.animationDuration = 2 + Math.random() * 3 + "s";
    snowflake.style.opacity = Math.random();
    snowflake.style.fontSize = Math.random() * 10 + 10 + "px";
    snowflake.innerText = "❄";
    document.querySelector(".header").appendChild(snowflake);
    setTimeout(() => {
      snowflake.remove();
    }, 5000);
  };

  setInterval(createSnowflake, 200);
})();
